import { render, staticRenderFns } from "./OrderPaymentDetails.vue?vue&type=template&id=cbf7e064&"
import script from "./OrderPaymentDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderPaymentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports